import { useState, useEffect } from 'react'
import { getProfiles } from '../services/api'

const styles = {
  container: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)',
    padding: '20px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  header: {
    color: '#fff',
    fontSize: '28px',
    fontWeight: 'bold',
    marginBottom: '10px',
    textAlign: 'center',
  },
  controls: {
    display: 'flex',
    alignItems: 'stretch',
    gap: '15px',
    marginTop: '40px',
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
  version: {
    position: 'fixed',
    bottom: '10px',
    right: '10px',
    fontSize: '10px',
    color: '#666',
    fontFamily: 'monospace',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
    gap: '20px',
    maxWidth: '800px',
    width: '100%',
  },
  profileButton: {
    padding: '40px 20px',
    fontSize: '24px',
    fontWeight: 'bold',
    border: 'none',
    borderRadius: '20px',
    cursor: 'pointer',
    transition: 'transform 0.2s, box-shadow 0.2s',
    color: '#fff',
    textShadow: '1px 1px 2px rgba(0,0,0,0.3)',
  },
  adminButton: {
    padding: '15px 30px',
    fontSize: '16px',
    background: 'transparent',
    border: '2px solid #666',
    borderRadius: '10px',
    color: '#888',
    cursor: 'pointer',
  },
}

function Landing({ onSelectProfile, onAdmin }) {
  // Git hash injected at build time
  const gitHash = typeof __GIT_HASH__ !== 'undefined' ? __GIT_HASH__ : 'dev'
  const [profiles, setProfiles] = useState([])

  useEffect(() => {
    getProfiles().then(setProfiles).catch(console.error)
  }, [])

  const toggleFullscreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen()
    } else {
      document.exitFullscreen()
    }
  }

  return (
    <div style={styles.container}>
      <h1 style={styles.header}>🎵 Musikverein Essensstand</h1>

      <div style={styles.grid}>
        {profiles.map((profile) => (
          <button
            key={profile.id}
            onClick={() => onSelectProfile(profile)}
            style={{
              ...styles.profileButton,
              background: profile.color,
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = 'scale(1.05)'
              e.target.style.boxShadow = '0 10px 30px rgba(0,0,0,0.3)'
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'scale(1)'
              e.target.style.boxShadow = 'none'
            }}
          >
            {profile.name}
          </button>
        ))}
      </div>

      <div style={styles.controls}>
        <button style={styles.adminButton} onClick={toggleFullscreen}>
          ⛶ Vollbild
        </button>
        <button style={styles.adminButton} onClick={onAdmin}>
          🔧 Admin
        </button>
      </div>

      <div style={styles.version}>{gitHash}</div>
    </div>
  )
}

export default Landing
